/**
 * Created by fers on 22/11/16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {convertFromBoxesToView} from './convertFromBoxesToView';
import {AllowedScreenDisplayer} from './DragAndDrop.react.js';

class BoxesToAdd extends React.Component {
    static propTypes = {
        canModify: PropTypes.bool,
        dataSource: PropTypes.object.isRequired,
        dataSourceList: PropTypes.object.isRequired,
        hasManyDataSources: PropTypes.bool,
        idx: PropTypes.number,
        intl: PropTypes.object,
        screen: PropTypes.object.isRequired,
        screenSettings: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
    }

    showBoxesToAdd(screen, dataSource, entityDef) {
        if (!dataSource) {
            return;
        }

        return (
            <AllowedScreenDisplayer
                asList
                canModify={this.props.canModify}
                isPreview
                screen={screen}
                screenSettings={this.props.screenSettings}
                viewsWithData={dataSource.boxesToAdd ? dataSource.boxesToAdd.map((node) => {
                    return convertFromBoxesToView(node, screen, dataSource, entityDef);
                }) : []}
            />
        );
    }

    render() {
        let dataSource = this.props.dataSource;
        let screen = this.props.screen;

        if (dataSource.primaryEntityDef) {
            return (
                <div className="dataSource-item-boxes">
                    {this.showBoxesToAdd(screen, dataSource, dataSource.primaryEntityDef)}
                </div>
            );
        }
    }
}

export default BoxesToAdd;
